export const TERMS_AND_CONDITIONS_DESKTOP = "Hopper Terms & Conditions";
export const TERMS_AND_CONDITIONS_MOBILE = ["Hopper Terms", "& Conditions"];
export const TERMS_OF_USE_DESKTOP = "Site Terms of Use";
export const TERMS_OF_USE_MOBILE = ["Site Terms", "of Use"];
export const PRIVACY = "Privacy Policy";
export const FAQS = "FAQs";

export const LEGAL = `© ${new Date().getFullYear()} Hopper`;
export const POWERED_BY = "Powered by";

export const PRIVACY_LINK =
  "https://www.uber.com/legal/en/document/?name=privacy-notice&country=great-britain&lang=en";
export const TERMS_AND_CONDITIONS_LINK =
  "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en";
export const FAQS_LINK =
  "https://help.hopper.com/en_us/categories/help-with-flights-Hywr1lPz_";
